import { Modal } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Input from "../../input/Input";
import styles from "./CompanySelectionModal.module.scss";
import _ from "lodash";
import classNames from "classnames";
import Button from "../../button/Button";
import taxPayersService from "../../../apis/services/admin/taxPayersService";

const CompanySelectionModal = ({
  modalOpen,
  onClose,
  onChoose,
  selectedCompanyId,
}) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState(0);

  const loadCompanies = async (pageNum = 1, search = "") => {
    try {
      setLoading(true);
      const response = await taxPayersService.fetchTaxpayers(pageNum, 20, search);
      const companiesData = response.data?.data || [];
      let companiesArray = [];
      
      if (Array.isArray(companiesData)) {
        companiesArray = companiesData;
      } else if (companiesData && Array.isArray(companiesData.data)) {
        companiesArray = companiesData.data;
      }
      
      if (pageNum === 1) {
        setCompanies(companiesArray);
      } else {
        setCompanies(prev => [...prev, ...companiesArray]);
      }
      
      const totalCount = response.data?.total || companiesArray.length;
      setTotal(totalCount);
      setHasMore(companiesArray.length === 20 && companies.length + companiesArray.length < totalCount);
      setPage(pageNum);
    } catch (error) {
      console.error("Error loading companies:", error);
    } finally {
      setLoading(false);
    }
  };

  const searchCompanies = _.debounce((search) => {
    setPage(1);
    loadCompanies(1, search);
  }, 600);

  useEffect(() => {
    if (modalOpen) {
      loadCompanies(1, "");
      if (selectedCompanyId) {
        // Find and select the company if ID is provided
        taxPayersService.fetchTaxpayers(1, 100, "")
          .then(response => {
            const allCompanies = response.data?.data || [];
            const company = allCompanies.find(c => 
              c.id === parseInt(selectedCompanyId) || 
              c.id.toString() === selectedCompanyId.toString()
            );
            if (company) {
              setSelectedCompany(company);
            }
          });
      }
    }
  }, [modalOpen]);

  useEffect(() => {
    if (searchTerm !== undefined) {
      searchCompanies(searchTerm);
    }
  }, [searchTerm]);

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      loadCompanies(page + 1, searchTerm);
    }
  };

  const handleChoose = () => {
    if (selectedCompany) {
      onChoose(selectedCompany);
      onClose();
    }
  };

  const renderItem = (company) => {
    return (
      <div
        className={classNames(
          styles.itemWrap,
          company?.id === selectedCompany?.id && styles.selected
        )}
        onClick={() => {
          if (company?.id === selectedCompany?.id) {
            setSelectedCompany(null);
          } else {
            setSelectedCompany(company);
          }
        }}
      >
        <div className={styles.configRow}>
          <div className={styles.configLabel}>
            <p className={styles.textBold}>Naziv:</p>
          </div>
          <div className={styles.configValue}>
            <p>{company.name}</p>
          </div>
        </div>
        <div className={styles.configRow}>
          <div className={styles.configLabel}>
            <p className={styles.textBold}>PIB:</p>
          </div>
          <div className={styles.configValue}>
            <p>{company.PIB}</p>
          </div>
        </div>
        {company.address && (
          <div className={styles.configRow}>
            <div className={styles.configLabel}>
              <p className={styles.textBold}>Adresa:</p>
            </div>
            <div className={styles.configValue}>
              <p>{company.address.name}</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal open={modalOpen} onClose={onClose}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <p className={styles.title}>Izaberite kompaniju</p>
          <div className={styles.inputWrapper}>
            <Input
              onChange={setSearchTerm}
              value={searchTerm}
              placeholder="Pretraži kompanije..."
            />
          </div>
          <div className={styles.listWrapper}>
            {companies.map((company) => <div key={company.id}>{renderItem(company)}</div>)}
            {loading && <p className={styles.loadingText}>Učitavanje...</p>}
            {hasMore && !loading && (
              <Button
                name="Učitaj više"
                onClick={handleLoadMore}
                type="button"
              />
            )}
            {companies.length === 0 && !loading && (
              <p className={styles.emptyText}>Nema kompanija</p>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            name="Odaberi"
            onClick={handleChoose}
            disabled={selectedCompany === null}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CompanySelectionModal;

